import styled from '@emotion/styled';
import { Box, Grid, Typography } from '@mui/material';
import React from 'react';
import { AllImage } from '../styling/style';
import { useEffect } from 'react'
import AOS from "aos";
import "aos/dist/aos.css";
import Aos from 'aos';

const BoxStyle = styled(Box)`
    background: ${props => props.backbg? props.backbg : 'linear-gradient( to top, #000000, #1C1C1C )'};
    min-height: ${props => props.minh? props.minh : ''};
    max-width: ${props => props.mw? props.mw : '250px'} ;
    border-radius: 20px 20px;
    padding: ${props => props.pd? props.pd : '20px'};
    margin: 20px auto;
`
const Para = styled(Typography)`
    font-family: poppins-regular;
    color: white;
    font-size: 14px;
    padding: 5px 0px;
    margin: ${props => props.m? props.m : ''};
`
const Para1 = styled(Typography)`
    font-family: poppins-semibold;
    color: white;
    font-size: 18px;
    background: ${props => props.bg? props.bg : ''} ;
    border-radius: 10px;
    padding: ${props => props.p? props.p : ''};
`
const Disc  = (props)=> <Para>{props.detail}</Para>
const FeatureCard = (props) => {
    const{tag, image, data} = props;
    useEffect(() => {
        Aos.init({
          duration: 800,
          offset: 200,
        });
      }, []);
    
      useEffect(() => {
        AOS.refresh();
      });
    return(
        <BoxStyle xs={12} md={4} {...props} data-aos="zoom-in-up" data-aos-duration = '1000'>
            <AllImage maxw='50px' src={image}/>
            <Para1 variant='h6' {...props}>{tag}</Para1>
            <div>
            {data?.map((val, ind)=> {
                return <Disc key={ind} detail={val[0]}/>
            })}
            </div>
        </BoxStyle>
    )
}

export default FeatureCard;